<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="d-flex">
          <h2 class="mainTitle">VIP Record</h2>
          <v-spacer />
          <v-btn text @click="loadVIPRecord">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="!record">
      <v-alert type="info" text>No VIP record found for this profile.</v-alert>
    </div>
    <div v-else>
      <v-card flat>
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <thead>
                <tr>
                  <th>Created At</th>
                  <th>Duration</th>
                  <th>Payment Method</th>
                  <th>Status</th>
                  <th>Created By</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="durationRecord of computedDurationRecords" :key="durationRecord._id">
                  <td>
                    {{ durationRecord.createdAt | moment }}
                  </td>
                  <td>
                    <div v-if="durationRecord.durationInSeconds">
                      {{ durationRecord.durationInSeconds | durationInSecondToDay }}
                    </div>
                    <div v-else>Permanent</div>
                  </td>
                  <td>
                    {{ durationRecord.paymentGateway | paymentMethod }}
                  </td>
                  <td>
                    <v-chip
                      outlined
                      label
                      :color="
                        durationRecord.paymentStatus === subscriptionPlanPaymentStatus.paid
                          ? 'primary'
                          : ''
                      "
                    >
                      {{
                        durationRecord.paymentStatus
                          | translateOptions(subscriptionPlanPaymentStatusOption)
                      }}</v-chip
                    >
                  </td>
                  <td>
                    {{ (durationRecord.createdBy && durationRecord.createdBy.name) || '-' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import api from '@/api';
import { crudList } from '@/api/crud';
import CustomLabel from '@/components/customFormLabel/customLabel';
import { RESTFUL, subscriptionPlanPaymentStatus, subscriptionPlanStatus } from '@/data/constants';
import {
  subscriptionPlanPaymentStatusOption,
  subscriptionPlanStatusOption,
} from '@/data/optionsConstants';
import moment from 'moment';

export default {
  name: 'IdentityVIPRecord',
  components: { CustomLabel },
  props: {
    profileId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      subscriptionPlanStatus,
      subscriptionPlanPaymentStatus,
      subscriptionPlanPaymentStatusOption,
      subscriptionPlanStatusOption,
      record: null,
      loading: false,
    };
  },
  mounted() {
    this.loadVIPRecord();
  },
  computed: {
    computedDurationRecords() {
      return (this.record?.durationRecords || []).sort(
        (a, b) => moment(b.createdAt) - moment(a.createdAt),
      );
    },
  },
  methods: {
    async loadVIPRecord() {
      if (!this.profileId) return;

      try {
        this.loading = true;
        const result = await crudList(api, RESTFUL.subscriptionPlanPurchaseRecord.list, {
          owner: this.profileId,
          populates: ['subscriptionPlan', 'owner', 'createdBy', 'durationRecords.createdBy'],
          limit: 1,
          sort: { createdAt: -1 },
        });

        if (result?.length > 0) {
          this.record = result[0];
        } else {
          this.record = null;
        }
      } catch (e) {
        console.error('Failed to load VIP record:', e);
        this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Failed to load VIP record',
          type: 'error',
          color: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
